/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Materials from '../../components/task/working/materials';
import {ts_translate} from "../../common/clientTranslate";

const MainWrapper = styled(FlexRootWrapper)`
	width: 100%%;
	flex-direction: row;
`;

const ImageWrapper = styled.div`
	width: 41%;
	min-width: 290px;
	margin-right: 20px;
	& img {
		width: 100%;
		height: auto;
	}
`;

const DescriptionWrapper = styled.div`
	margin-top: 20px;
`;

const DescriptionText = styled.p`
	padding-bottom: ${({padding}) => padding}px;
	${({big}) => big ? 'font-size: 20px;' : ''}
`;

const Content = ({
                     image,
                     stepNumber,
                     step,
                     materials,
                 }) => (
    <FlexRootWrapper>
        <MainWrapper>
            <DescriptionWrapper>
                <DescriptionText padding={3}>{ts_translate('Aktueller Arbeitsschritt')}: {stepNumber}</DescriptionText>

                <DescriptionText big padding={27}>{step}</DescriptionText>

                {materials && (
                    <Materials materials={materials}/>
                )}
            </DescriptionWrapper>
        </MainWrapper>
    </FlexRootWrapper>
);

export default Content;



// WEBPACK FOOTER //
// ./src/containers/disponent/content.js